import { render, staticRenderFns } from "./ServiceCategoryComponent.vue?vue&type=template&id=6d359d4a&scoped=true&"
import script from "./ServiceCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d359d4a",
  null
  
)

export default component.exports